import { render, staticRenderFns } from "./tagging-banner.component.vue?vue&type=template&id=f762d33a&scoped=true"
import script from "./tagging-banner.component.vue?vue&type=script&lang=ts"
export * from "./tagging-banner.component.vue?vue&type=script&lang=ts"
import style0 from "./tagging-banner.component.vue?vue&type=style&index=0&id=f762d33a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f762d33a",
  null
  
)

export default component.exports